import { api, handleApiError } from '../client'

export interface DashboardStats {
  totalTemplates: number
  totalAssets: number
  totalUsers: number
  activeUsers: number
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await api.get<DashboardStats>('/v1/dashboard/stats')
      return response.data
    } catch (error) {
      throw new Error(handleApiError(error))
    }
  },
}
